import React, { useState } from 'react'
import NoteForm from '../note-form/NoteForm'
import APIResponse from '../../../../templates/components/APIResponse'
import DimLoader from '../../../../templates/components/DimLoader'
import PatientService from '../../../../../services/api/patient.service'

const NoteAdd = (props) => {
    const [noteFormData, setNoteFormData] = useState(props.initialData)
    const [apiResponse, setApiResponse] = useState()
    const [isLoader, setIsLoader] = useState(false)
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const submitHandler = (data) => {
        setIsLoader(true)
        const reqObj = {
            description: data?.description,
            title: data?.title
        }
        PatientService.addNote(reqObj, noteFormData?.patientId)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }
    return (
        <>
            {isLoader &&
                <DimLoader loadMessage="Processing" />
            }
            <NoteForm submitHandler={submitHandler} initialFormData={noteFormData} onClose={() => { props.onClose() }} />
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
        </>
    )
}

export default NoteAdd